import { observer } from 'mobx-react'
import React, { Component } from 'react'
import Card from '../../components/Card'
import Input from '../../components/Input'
import Row from '../../components/Row'
import Select from '../../components/Select'
import patient from '../../stores/patient'

@observer
export default class ProfileForm extends Component {
  render() {
    return (
      <Card>
        <Card.Pad>
          <Row>
            <Row.Cell flex="2">
              <Input
                label="titles.patientName"
                name="name"
                value={patient.fields.name}
                onChange={patient.setField}
              />
            </Row.Cell>
            <Row.Cell>
              <Input
                label="titles.patientUID"
                value={patient.fields.patientUID}
                name="patientUID"
                onChange={patient.setField}
              />
            </Row.Cell>
            <Row.Cell>
              <Select
                label="titles.gender"
                name="gender"
                value={patient.fields.gender}
                onChange={patient.setField}
              >
                <Select.Options choices="gender" />
              </Select>
            </Row.Cell>
            <Row.Cell>
              <Select
                label="titles.lowVision"
                name="lowVision"
                value={patient.fields.lowVision}
                onChange={patient.setField}
              >
                <Select.Options choices="lowVision" />
              </Select>
            </Row.Cell>
          </Row>
          {patient.isCombat && <Row><Row.Cell>
            <Select
              label="titles.questionThreeScore"
              name="questionThreeScore"
              value={patient.fields.questionThreeScore}
              onChange={patient.setField}
            >
              <Select.Options choices="yesNo" />
            </Select>
            <Select
              label="titles.questionFourScore"
              name="questionFourScore"
              value={patient.fields.questionFourScore}
              onChange={patient.setField}
            >
              <Select.Options choices="yesNo" />
            </Select>
            <Select
              label="titles.questionFiveScore"
              name="questionFiveScore"
              value={patient.fields.questionFiveScore}
              onChange={patient.setField}
            >
              <Select.Options choices="yesNo" />
            </Select>
            <Select
              label="titles.isChristian"
              name="isChristian"
              value={patient.fields.isChristian}
              onChange={patient.setIsChristian}
            >
              <Select.Options choices="yesNo" />
            </Select>
            {patient.fields.isChristian === 'YES' &&
              <Input
                label="titles.whatFaith"
                name={'whatFaith'}
                value={patient.fields.whatFaith || ''}
                onChange={patient.setField}
              />}
          </Row.Cell>
          </Row>
          }
          <Row>
            <Row.Cell>
              <Select
                label="titles.birthYear"
                name="birthYear"
                value={patient.birthYear}
                onChange={patient.setBirthYear}
              >
                {[...Array((new Date()).getFullYear()-1900).keys()].map(v => (new Date()).getFullYear()-v).map(v => (
                  <option value={v} key={v}>{v}</option>
                ))}
              </Select>
            </Row.Cell>
            <Row.Cell>
              <Select
                label="titles.birthMonth"
                name="birthMonth"
                value={patient.birthMonth}
                onChange={patient.setBirthMonth}
              >
                <Select.Options choices="month" />
              </Select>
            </Row.Cell>
            <Row.Cell>
              <Select
                label="titles.birthDay"
                name="birthDay"
                value={patient.birthDay}
                onChange={patient.setBirthDay}
              >
                {[...Array(patient.daysInBirthMonth).keys()].map(v => (
                <option key={v} value={(v+1).toString().padStart(2, '0')}>{v+1}</option>
                ))}
              </Select>
            </Row.Cell>
          </Row>
          <Row>
            <Row.Cell>
              <Select
                label="titles.ethnicity"
                name="ethnicity"
                value={patient.fields.ethnicity}
                onChange={patient.setField}
              >
                <Select.Options choices="ethnicity" />
              </Select>
            </Row.Cell>
            <Row.Cell>
              <Select
                label="titles.diagnosis"
                name="diagnosis"
                value={patient.fields.diagnosis}
                onChange={patient.setField}
              >
                <Select.Options choices="diagnosis" />
              </Select>
            </Row.Cell>
          </Row>
          <Row>
            <Row.Cell flex="2">
              <Input
                label="titles.doctor"
                name="doctor"
                value={patient.fields.doctor}
                onChange={patient.setField}
              />
            </Row.Cell>
            <Row.Cell>
              <Select
                label="titles.gender"
                name="doctorGender"
                value={patient.fields.doctorGender}
                onChange={patient.setField}
              >
                <Select.Options choices="gender" />
              </Select>
            </Row.Cell>
          </Row>
        </Card.Pad>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/EditPatient/ProfileForm.js